/**
 * The closed set of contact-form inquiry types. Shared so the form, the tRPC
 * router input (z.enum), and the sales email all agree on exactly these values
 * and prevents free-form strings from landing in the SalesInquiry.inquiryType
 * column and keeping downstream triage/routing reliable.
 */
export const INQUIRY_TYPES = [
  "Run research for my company",
  // Worded as the buyer's model: experts who want AI-training *work* read the
  // old "Train or evaluate an AI model" label as a job and picked it.
  "Get human data for my AI model",
  "Recruit a niche audience",
  "Partner with Terac",
  "Events and sponsorships",
  "Something else",
] as const;

export type InquiryType = (typeof INQUIRY_TYPES)[number];

/**
 * Maps the `?inquiry=` deep-link query param (used by CTAs like the Partners
 * page) to the matching inquiry type so the form arrives pre-scoped.
 */
export const INQUIRY_PARAM_TO_TYPE: Record<string, InquiryType> = {
  research: "Run research for my company",
  "ai-training": "Get human data for my AI model",
  recruitment: "Recruit a niche audience",
  partnership: "Partner with Terac",
  events: "Events and sponsorships",
};
